import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props {
  handleCleanChat: () => void;
  closeModal: (id: TModalsIds) => void;
}

export const CleanSpaChatModal = ({ handleCleanChat, closeModal }: Props) => {
  const cleanSpaChat = useModalSelectors("clean_spa_chat_modal");
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={cleanSpaChat.isOpen}
      closeModal={() => closeModal("clean_spa_chat_modal")}
      onClose={() => closeModal("clean_spa_chat_modal")}
      onOk={() => {
        handleCleanChat();
        closeModal("clean_spa_chat_modal");
      }}
      onCancel={() => {
        closeModal("clean_spa_chat_modal");
      }}
      isWarningButton
      buttonOkText={"Подтвердить"}
      hasFooter
    >
      <div className={styles.body}>
        <div>
          Вы действительно хотите очистить чат? Сгенерированный моделью код
          приложения также будет очищен.
        </div>
      </div>
    </ModalBasic>
  );
};
